// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"24":"a26047b334bcbd94","463":"26e55d900a2a2f5d","705":"fafede46bdf5bcf7"}[chunkId] + ".js";
};